import axios from "./Axios";
import { axiosPrivate } from "./AxiosPrivate";

//Buyer Request

export const getSingleBuyer = (id) =>
  axiosPrivate.get(`/common/getSingleBuyer/${id}`);

//Bid Request

export const getAllBid = (paramsData) =>
  axiosPrivate.get("/common/get-all-bid", { params: paramsData });
export const getAllBidRequest = (paramsData) =>
  axiosPrivate.get("/common/get-all-bid-request", { params: paramsData });
export const getSingleBid = (id) =>
  axiosPrivate.get(`/common/get-single-bid/${id}`);
export const rejectBid = (bidID, note) =>
  axiosPrivate.put(`/common/reject-bid/${bidID}`, note);
export const approveBid = (bidID, data) =>
  axiosPrivate.put(`/common/approve-bid/${bidID}`, data);
export const scheduleBid = (bidID, data) =>
  axiosPrivate.put(`/common/schedule-bid/${bidID}`, data);
export const getBiddedData = (bidID,activeTab) =>
  axiosPrivate.post(`/common/get-bidded-data/${bidID}`,activeTab);
export const sellBid = (bidID, data) =>
  axiosPrivate.put(`/common/sell-bid/${bidID}`, data);
export const reBid = (bidID, data) =>
  axiosPrivate.put(`/common/re-bid/${bidID}`, data);
export const closeBid = (bidID, rejectNote) =>
  axiosPrivate.put(`/common/close-bid/${bidID}`, { rejectNote: rejectNote });
export const saveSoldDetails = (bidID, data) =>
  axiosPrivate.put(`/common/save-soldDetails/${bidID}`, data);
//Category

export const fetchCategory = () => axios.get(`/common/get-category`);

//Group

export const getAllGroup = (paramsData) =>
  axiosPrivate.get("/common/getAllGroup", { params: paramsData });

//Surveyor Request

export const getAllSurveyor = (paramsData) =>
  axiosPrivate.get("/common/get-all-surveyor", { params: paramsData });
export const createSurveyor = (formData) =>
  axiosPrivate.post(`/common/create-surveyor`, formData);
export const updateSurveyor = (id, formData) =>
  axiosPrivate.put(`/common/update-surveyor/${id}`, formData);
export const getSingleSurveyor = (id) =>
  axiosPrivate.get(`/common/get-single-surveyor/${id}`);
export const updateSurveyorStatus = (id, status) =>
  axiosPrivate.put(`/common/update-surveyor-status/${id}`, { status });
export const getSurveyorBidList = (id, paramsData) =>
  axiosPrivate.get(`/common/get-surveyor-bidlist/${id}`, {
    params: paramsData,
  });
export const getSurveyorSurveyList = (id, paramsData) =>
  axiosPrivate.get(`/common/get-surveyor-surveylist/${id}`, {
    params: paramsData,
  });

//Survey Request
export const getAssignedSurvey = (paramsData) =>
  axiosPrivate.get("/common/get-assigned-survey", { params: paramsData });
export const getUnAssignedSurvey = (paramsData) =>
  axiosPrivate.get("/common/get-unassigned-survey", { params: paramsData });
export const createSurvey = (data) =>
  axiosPrivate.post(`/common/create-survey`, data);
export const updateSurvey = (id, data) =>
  axiosPrivate.put(`/common/update-survey/${id}`, data);
export const getSingleSurvey = (id) =>
  axiosPrivate.get(`/common/get-single-survey/${id}`);
export const getSurveyBidList = (id, paramsData) =>
  axiosPrivate.get(`/common/get-survey-bidlist/${id}`, { params: paramsData });
export const getSurveySettlements = (paramsData) =>
  axiosPrivate.get("/common/get-survey-settlement", { params: paramsData });
export const fundTransfer = (data) =>
  axiosPrivate.post(`/common/fundTransfer`, data);

export const getSurveyorToAssign = (paramsData) =>
  axiosPrivate.get("/common/get-surveyor-to-assign", { params: paramsData });
export const assignSurvey = (id, data) =>
  axiosPrivate.put(`/common/assign-survey/${id}`, data);
export const reassignSurvey = (id, data) =>
  axiosPrivate.put(`/common/reassign-surveyor/${id}`, data);
